/* ====================================================================
   QUEEN LENGTH V2 — fast-CTA layout JS
   - Qty stepper (+/- buttons) synced between main and sticky
   - Shade drawer toggle (collapsed by default)
   - Shade picker → updates hidden variant ID + hero image + price
   - Sticky bar visibility via IntersectionObserver
   - Sticky bar CTA delegates to real form submit
   - Cart drawer opens after add-to-cart
   ==================================================================== */

(function () {
  'use strict';

  function formatMoney(cents, symbol) {
    var s = symbol || '$';
    var num = Math.round(cents) / 100;
    var amount = num % 1 === 0 ? num.toString() : num.toFixed(2);
    return s + amount;
  }

  function init(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-ql-section]');
    sections.forEach(initSection);
  }

  function initSection(section) {
    if (section.dataset.qlInit === '1') return;
    section.dataset.qlInit = '1';

    var currencySymbol = section.dataset.qlCurrency || '$';
    var unitMode = section.dataset.qlUnitMode || 'packs';
    var gramsPerPack = parseInt(section.dataset.qlGrams || '90', 10);

    var state = {
      unitCents: parseInt(section.dataset.qlBasePrice || '0', 10),
      qty: 1,
      shadeName: ''
    };

    // ----- Cache nodes
    var qtyInput = section.querySelector('[data-ql-qty]');
    var variantInput = section.querySelector('[data-ql-variant-id]');
    var totalEls = section.querySelectorAll('[data-ql-total]');
    var unitEls = section.querySelectorAll('[data-ql-unit]');
    var heroImg = section.querySelector('[data-ql-hero]');
    var shadeNameEls = section.querySelectorAll('[data-ql-shade-name]');
    var selectedNameEl = section.querySelector('[data-qlv2-selected-name]');
    var stickybar = section.querySelector('[data-ql-stickybar]');
    var mainCta = section.querySelector('[data-ql-main-cta]');
    var stickyCta = section.querySelector('[data-ql-sticky-cta]');
    var tierChips = section.querySelectorAll('[data-ql-tier]');
    var bundleMsgEl = section.querySelector('[data-qlv2-bundle-msg]');
    var bundleTiles = section.querySelectorAll('[data-ql-bundle-select]');

    // Stepper elements (main)
    var minusBtn = section.querySelector('[data-ql-qty-minus]');
    var plusBtn = section.querySelector('[data-ql-qty-plus]');
    var qtyDisplay = section.querySelector('[data-ql-qty-display]');

    // Stepper elements (sticky)
    var stickyMinusBtn = section.querySelector('[data-ql-sticky-minus]');
    var stickyPlusBtn = section.querySelector('[data-ql-sticky-plus]');
    var stickyQtyDisplay = section.querySelector('[data-ql-sticky-qty-display]');
    var stickyPrice = section.querySelector('[data-ql-sticky-price]');

    // Shade section


    // ----- Render all dynamic elements
    function render() {
      var totalCents = state.unitCents * state.qty;
      // Bundle discount for the current qty (Shopify auto-discount: 4+ -> 12%, 8+ -> 20%, 12+ -> 25%).
      // The Add to Cart + sticky price show the REAL price you pay, not the pre-discount total.
      // Same math as the Mix & Save tiles + the savings line below, so it matches the cart exactly.
      var bundleRate = state.qty >= 12 ? 0.25 : state.qty >= 8 ? 0.20 : state.qty >= 4 ? 0.12 : 0;
      var totalStr = formatMoney(totalCents - Math.round(totalCents * bundleRate), currencySymbol);
      var unitStr = formatMoney(state.unitCents, currencySymbol);

      totalEls.forEach(function (el) { el.textContent = totalStr; });
      unitEls.forEach(function (el) { el.textContent = unitStr; });

      // Qty displays (support both input and span)
      if (qtyDisplay) {
        if (qtyDisplay.tagName === 'INPUT') qtyDisplay.value = state.qty;
        else qtyDisplay.textContent = state.qty;
      }
      if (stickyQtyDisplay) {
        if (stickyQtyDisplay.tagName === 'INPUT') stickyQtyDisplay.value = state.qty;
        else stickyQtyDisplay.textContent = state.qty;
      }

      // Sticky price = total
      if (stickyPrice) stickyPrice.textContent = totalStr;

      // Qty input
      if (qtyInput) qtyInput.value = state.qty;

      // Tier chips
      tierChips.forEach(function (chip) {
        var tier = parseInt(chip.getAttribute('data-ql-tier'), 10);
        chip.classList.toggle('ql-tier--active', state.qty >= tier);
      });

      // Reflect which Mix & Save tile matches the current qty
      bundleTiles.forEach(function (t) {
        var on = parseInt(t.getAttribute('data-ql-bundle-select'), 10) === state.qty;
        t.classList.toggle('qlv2-mixsave__col--selected', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      // ----- Live bundle savings message — Mix & Save ladder 4/8/12 (decided 2026-05-21)
      // Tiers (Shopify automatic discount, scoped to braids & locs): 4+ → 12%, 8+ → 20%, 12+ → 25%
      if (bundleMsgEl) {
        var q = state.qty;
        var subtotalCents = state.unitCents * q;
        var rate = bundleRate;
        var savedCents = Math.round(subtotalCents * rate);
        var savedStr = formatMoney(savedCents, currencySymbol);
        var msg = '';
        var unlocked = rate > 0;
        var packs = function (n) { return n === 1 ? 'pack' : 'packs'; };

        // The button now shows the discounted price, so this line no longer repeats it —
        // it just confirms the saving and nudges the next tier (premium, uncluttered).
        if (q >= 12) {
          msg = '✓ Best value · save ' + savedStr;
        } else if (q >= 8) {
          msg = '✓ 20% off · save ' + savedStr + ' · add ' + (12 - q) + ' more for 25%';
        } else if (q >= 4) {
          msg = '✓ 12% off · save ' + savedStr + ' · add ' + (8 - q) + ' more for 20%';
        } else {
          var to12 = 4 - q;
          msg = 'Add ' + to12 + ' more ' + packs(to12) + ' → 12% off';
        }
        bundleMsgEl.textContent = msg;
        bundleMsgEl.classList.toggle('qlv2-bundle-savings--unlocked', unlocked);
      }

      // Sticky shade name
      var stickyShadeEl = section.querySelector('[data-ql-sticky-shade]');
      if (stickyShadeEl && state.shadeName) stickyShadeEl.textContent = state.shadeName;
    }

    // ----- Qty stepper logic
    function changeQty(delta) {
      var newQty = state.qty + delta;
      if (newQty < 1) newQty = 1;
      if (newQty > 20) newQty = 20;
      state.qty = newQty;
      render();
    }

    if (minusBtn) minusBtn.addEventListener('click', function () { changeQty(-1); });
    if (plusBtn) plusBtn.addEventListener('click', function () { changeQty(1); });
    if (stickyMinusBtn) stickyMinusBtn.addEventListener('click', function () { changeQty(-1); });
    if (stickyPlusBtn) stickyPlusBtn.addEventListener('click', function () { changeQty(1); });

    function setQtyFromInput(inp) {
      var n = parseInt(inp.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 20) n = 20;
      state.qty = n;
      render();
    }
    if (qtyDisplay && qtyDisplay.tagName === 'INPUT') {
      qtyDisplay.addEventListener('change', function () { setQtyFromInput(qtyDisplay); });
      qtyDisplay.addEventListener('blur', function () { setQtyFromInput(qtyDisplay); });
      qtyDisplay.addEventListener('input', function () {
        qtyDisplay.value = qtyDisplay.value.replace(/[^0-9]/g, '');
      });
    }
    if (stickyQtyDisplay && stickyQtyDisplay.tagName === 'INPUT') {
      stickyQtyDisplay.addEventListener('change', function () { setQtyFromInput(stickyQtyDisplay); });
      stickyQtyDisplay.addEventListener('blur', function () { setQtyFromInput(stickyQtyDisplay); });
      stickyQtyDisplay.addEventListener('input', function () {
        stickyQtyDisplay.value = stickyQtyDisplay.value.replace(/[^0-9]/g, '');
      });
    }

    // ----- Mix & Save tiles → tap to set the bundle quantity (added 2026-05-30)
    // These tiles looked tappable but did nothing (Clarity dead-click hotspot). A tap
    // now sets qty to that pack count; render() highlights the matching tile; then we
    // bring the Add to Cart into view and pulse it so the next step is obvious.
    function pulseMainCta() {
      if (!mainCta) return;
      mainCta.classList.remove('qlv2-cta--pulse');
      void mainCta.offsetWidth; // restart the animation
      mainCta.classList.add('qlv2-cta--pulse');
      setTimeout(function () { mainCta.classList.remove('qlv2-cta--pulse'); }, 650);
    }
    function selectBundle(tile) {
      var n = parseInt(tile.getAttribute('data-ql-bundle-select'), 10);
      if (isNaN(n)) return;
      if (n < 1) n = 1;
      if (n > 20) n = 20;
      state.qty = n;
      render();
      if (mainCta && mainCta.scrollIntoView) {
        mainCta.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      pulseMainCta();
    }
    bundleTiles.forEach(function (tile) {
      tile.addEventListener('click', function () { selectBundle(tile); });
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          selectBundle(tile);
        }
      });
    });




    // ----- Show all shades expander
    var showAllBtn = section.querySelector('[data-qlv2-show-all]');
    var mainGrid = section.querySelector('[data-qlv2-main-grid]');
    if (showAllBtn && mainGrid) {
      showAllBtn.addEventListener('click', function () {
        mainGrid.classList.remove('qlv2-shade-grid--capped');
        mainGrid.classList.add('qlv2-shade-grid--expanded');
        showAllBtn.hidden = true;
      });
    }

    // ----- Shade picker
    var shadeRadios = section.querySelectorAll('[data-ql-shade]');
    var shadePreviewImg = section.querySelector('[data-qlv2-shade-preview-img]');

    function applyShade(radio, skipImage) {
      if (!radio || !radio.checked) return;

      // Auto-expand group
      expandGroupForRadio(radio);

      // Update name
      var name = radio.getAttribute('data-shade-name') || radio.value;
      state.shadeName = name;
      shadeNameEls.forEach(function (el) { el.textContent = name; });
      if (selectedNameEl) selectedNameEl.textContent = name;

      // Update variant ID in hidden input
      if (variantInput) variantInput.value = radio.value;

      // Update price
      var newPrice = parseInt(radio.getAttribute('data-price-cents') || '', 10);
      if (!isNaN(newPrice) && newPrice > 0) {
        state.unitCents = newPrice;
      }
      render();

      // Swap inline shade preview + top hero image (NO page scroll — 2026-05-22).
      // Old behaviour force-scrolled the viewport up to the hero on every pick, which
      // yanked candy-buyers away from the grid. Preview now lives at the swatches.
      if (!skipImage) {
        var imgUrl = radio.getAttribute('data-shade-image');
        if (imgUrl) {
          var s600 = radio.getAttribute('data-shade-image-600');
          var s900 = radio.getAttribute('data-shade-image-900');
          // Inline preview at the swatches — the customer sees the shade without moving
          if (shadePreviewImg) {
            if (s600 && s900) shadePreviewImg.srcset = s600 + ' 360w, ' + s900 + ' 600w';
            shadePreviewImg.src = imgUrl;
          }
          // Top hero — updated silently for when they scroll up to the gallery
          if (heroImg) {
            if (s600 && s900) heroImg.srcset = s600 + ' 600w, ' + s900 + ' 900w, ' + imgUrl + ' 1200w';
            heroImg.src = imgUrl;
          }
        }
        // Keep the gallery carousel aligned to the hero slide (horizontal only — never scrolls the page)
        var gallery = section.querySelector('.ql-gallery');
        if (gallery && heroImg) {
          var slide = heroImg.closest('.ql-gallery__slide');
          if (slide) {
            var slides = gallery.querySelectorAll('.ql-gallery__slide');
            var heroIndex = Array.prototype.indexOf.call(slides, slide);
            if (heroIndex >= 0) {
              gallery.scrollTo({ left: gallery.offsetWidth * heroIndex, behavior: 'smooth' });
              var dots = section.querySelectorAll('.ql-gallery__dot');
              dots.forEach(function (dot, i) {
                dot.classList.toggle('ql-gallery__dot--active', i === heroIndex);
              });
            }
          }
        }
      }

      // Update swatch visual state
      shadeRadios.forEach(function (r) {
        var label = r.closest('.ac-swatch');
        if (label) label.classList.toggle('is-selected', r.checked);
      });
    }

    shadeRadios.forEach(function (radio) {
      radio.addEventListener('change', function () { applyShade(radio); });
    });

    // ----- Swatch group collapse/expand
    var groupToggles = section.querySelectorAll('[data-ac-group-toggle]');
    groupToggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.ac-swatch-group');
        if (!group) return;
        var expanded = group.classList.toggle('ac-swatch-group--expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var more = btn.querySelector('[data-ac-group-toggle-more]');
        var less = btn.querySelector('[data-ac-group-toggle-less]');
        if (more) more.hidden = expanded;
        if (less) less.hidden = !expanded;
      });
    });

    function expandGroupForRadio(radio) {
      var group = radio.closest('.ac-swatch-group');
      if (!group || group.classList.contains('ac-swatch-group--expanded')) return;
      group.classList.add('ac-swatch-group--expanded');
      var btn = group.querySelector('[data-ac-group-toggle]');
      if (btn) {
        btn.setAttribute('aria-expanded', 'true');
        var more = btn.querySelector('[data-ac-group-toggle-more]');
        var less = btn.querySelector('[data-ac-group-toggle-less]');
        if (more) more.hidden = true;
        if (less) less.hidden = false;
      }
    }

    // ----- Initial state
    var initialChecked = section.querySelector('[data-ql-shade]:checked');
    if (initialChecked) {
      state.shadeName = initialChecked.getAttribute('data-shade-name') || '';
      if (variantInput) variantInput.value = initialChecked.value;
      var initPrice = parseInt(initialChecked.getAttribute('data-price-cents') || '', 10);
      if (!isNaN(initPrice) && initPrice > 0) state.unitCents = initPrice;
    }
    render();

    // ----- Bundle progress bar
    var ELIGIBLE_HANDLES = [
      '26-inch-pre-stretched-braiding-hair',
      '22-inch-pre-stretched-braiding-hair',
      '16-inch-pre-stretched-braiding-hair'
    ];
    var progressFill = section.querySelector('[data-qlv2-fill]');
    var progressMsg = section.querySelector('[data-qlv2-msg]');
    var progressMarkers = section.querySelectorAll('[data-qlv2-marker]');
    var prevTier = 0;

    var KIT_THRESHOLD = 7;
    var unitCentsForThreshold = state.unitCents || 1000;

    function updateProgressBar(count, animate) {
      if (!progressFill || !progressMsg) return;
      var pct = Math.min((count / KIT_THRESHOLD) * 100, 100);
      progressFill.style.width = pct + '%';

      // Update markers
      progressMarkers.forEach(function (m) {
        var val = parseInt(m.getAttribute('data-qlv2-marker'), 10);
        var hit = count >= val;
        m.classList.toggle('qlv2-progress__marker--hit', hit);
        if (animate && hit && !m.classList.contains('qlv2-progress__marker--pulsed')) {
          m.classList.add('qlv2-progress__marker--pulse');
          m.classList.add('qlv2-progress__marker--pulsed');
          setTimeout(function () { m.classList.remove('qlv2-progress__marker--pulse'); }, 700);
        }
      });

      var msg = '';
      var celebrate = false;
      var remaining = KIT_THRESHOLD - count;

      // Install Kit promo retired. Progress bar HTML removed from PDP, so
      // this function early-returns above. Strings cleared to avoid stale
      // install-kit copy if a future template re-adds the data attributes.
      msg = '';

      progressMsg.textContent = msg;
      progressMsg.classList.toggle('qlv2-progress__msg--celebrate', celebrate);
      if (celebrate) {
        setTimeout(function () {
          progressMsg.classList.remove('qlv2-progress__msg--celebrate');
        }, 2500);
      }

      prevTier = count;
    }

    function fetchCartAndUpdate(animate) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = 0;
          cart.items.forEach(function (item) {
            if (ELIGIBLE_HANDLES.indexOf(item.handle) !== -1) {
              count += item.quantity;
            }
          });
          updateProgressBar(count, animate);
        })
        .catch(function () {});
    }

    // Initial load
    fetchCartAndUpdate(false);

    // ----- Dynamic dispatch message — honest about weekends + after-cutoff
    // Order before 1pm AEST weekday → ships today
    // After 1pm weekday → ships tomorrow (or Monday if Fri)
    // Saturday/Sunday → ships Monday
    (function updateDispatchMessage() {
      var el = section.querySelector('[data-qlv2-dispatch]');
      if (!el) return;
      try {
        // Get current time in Australia/Sydney (AEST/AEDT — handles DST)
        var fmt = new Intl.DateTimeFormat('en-AU', {
          timeZone: 'Australia/Sydney',
          weekday: 'long', hour: 'numeric', hour12: false
        });
        var parts = fmt.formatToParts(new Date());
        var weekday = parts.find(function (p) { return p.type === 'weekday'; }).value; // "Monday" ... "Sunday"
        var hour = parseInt(parts.find(function (p) { return p.type === 'hour'; }).value, 10);
        var beforeCutoff = hour < 13; // before 1pm
        var msg;
        var weekdays = { Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6, Sunday: 0 };
        var d = weekdays[weekday];
        if (d >= 1 && d <= 5 && beforeCutoff) {
          msg = 'Order before <strong>1pm AEST</strong> → ships today';
        } else if (d === 5 && !beforeCutoff) {
          msg = 'Order now → ships <strong>Monday</strong>';
        } else if (d >= 1 && d <= 4 && !beforeCutoff) {
          msg = 'Order now → ships <strong>tomorrow</strong>';
        } else if (d === 6) {
          msg = 'Order now → ships <strong>Monday</strong>';
        } else if (d === 0) {
          msg = 'Order now → ships <strong>Monday</strong>';
        }
        if (msg) el.innerHTML = msg;
      } catch (e) {
        // Fallback to the default text already in HTML
      }
    })();

    // Estimated delivery date — NOBL-pattern conversion lever.
    // Shows a concrete date based on AEST cutoff + Aus Post Express metro (~1 business day after ship).
    // Falls back to "1-2 business days" if anything errors.
    (function updateDeliveryEstimate() {
      var el = section.querySelector('[data-qlv2-delivery]');
      if (!el) return;
      try {
        var aestParts = new Intl.DateTimeFormat('en-AU', {
          timeZone: 'Australia/Sydney',
          weekday: 'long', hour: 'numeric', hour12: false
        }).formatToParts(new Date());
        var weekday = aestParts.find(function (p) { return p.type === 'weekday'; }).value;
        var hour = parseInt(aestParts.find(function (p) { return p.type === 'hour'; }).value, 10);
        var beforeCutoff = hour < 13;
        var weekdays = { Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6 };
        var todayDay = weekdays[weekday];

        // Days from today until SHIP date
        var shipDays;
        if (todayDay === 0) shipDays = 1; // Sun → ships Mon
        else if (todayDay === 6) shipDays = 2; // Sat → ships Mon
        else if (todayDay === 5 && !beforeCutoff) shipDays = 3; // Fri after cutoff → ships Mon
        else if (todayDay >= 1 && todayDay <= 4 && !beforeCutoff) shipDays = 1; // Mon-Thu after cutoff → next day
        else shipDays = 0; // Mon-Fri before cutoff → ships today

        // Delivery = ship + 1 business day (Aus Post Express metro)
        var totalDays = shipDays + 1;
        var delivery = new Date();
        delivery.setDate(delivery.getDate() + totalDays);

        // If delivery lands on weekend, push to next Monday (Aus Post doesn't deliver weekends)
        var deliveryDay = delivery.getDay();
        if (deliveryDay === 0) delivery.setDate(delivery.getDate() + 1); // Sun → Mon
        if (deliveryDay === 6) delivery.setDate(delivery.getDate() + 2); // Sat → Mon

        var formatted = new Intl.DateTimeFormat('en-AU', {
          timeZone: 'Australia/Sydney',
          weekday: 'short', day: 'numeric', month: 'short'
        }).format(delivery);

        el.innerHTML = 'Est. delivery <strong>' + formatted + '</strong> <span class="qlv2-ship__delivery-note">(metro)</span>';
      } catch (e) {
        // Fallback to the default text already in HTML
      }
    })();

    // ----- Hoisted-review photo lightbox (tap face → see full install)
    section.querySelectorAll('[data-qlv2-review-photo]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var img = btn.querySelector('img');
        if (!img) return;
        var fullSrc = btn.getAttribute('data-full-src') || img.src;
        var alt = img.alt || 'Customer photo';
        var overlay = document.createElement('div');
        overlay.className = 'qlv2-photo-overlay';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.innerHTML =
          '<button type="button" class="qlv2-photo-overlay__close" aria-label="Close">×</button>' +
          '<img src="' + fullSrc + '" alt="' + alt.replace(/"/g, '&quot;') + '" class="qlv2-photo-overlay__img">';
        function close() {
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
          document.body.style.overflow = '';
          document.removeEventListener('keydown', onKey);
        }
        function onKey(ev) { if (ev.key === 'Escape') close(); }
        overlay.addEventListener('click', function (ev) {
          if (ev.target === overlay || ev.target.classList.contains('qlv2-photo-overlay__close')) close();
        });
        document.addEventListener('keydown', onKey);
        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';
      });
    });

    // ----- Sticky bar visibility
    var ctaRow = section.querySelector('[data-ql-cta-wrap]');
    if (stickybar && ctaRow && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          stickybar.classList.toggle('ql-stickybar--visible', visible);
          stickybar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(ctaRow);
    }

    // ----- Sticky CTA → real form submit
    if (stickyCta && mainCta) {
      stickyCta.addEventListener('click', function (e) {
        e.preventDefault();
        if (mainCta.disabled) return;
        mainCta.click();
      });
    }

    // ----- Inline "added" toast — FALLBACK ONLY since T1.1 (2026-05-31): the
    // cart drawer now opens on add; this fires only if the drawer can't open.
    var productFormEl = section.querySelector('[data-js-product-form]');
    var addedEl = section.querySelector('[data-qlv2-added]');
    var addedTextEl = section.querySelector('[data-qlv2-added-text]');
    var addedTimeout = null;

    function getNudgeText(count) {
      // Install Kit promo retired — bundle tier savings handled by the
      // bundle-tier-deal section + Shopify automatic discount.
      return '';
    }

    function showAddedConfirmation(shadeName, qty, cartCount) {
      if (!addedEl || !addedTextEl) return;
      var label = shadeName + (qty > 1 ? ' × ' + qty : '') + ' added!';
      var nudge = getNudgeText(cartCount);
      addedTextEl.textContent = nudge ? label + ' · ' + nudge : label;
      addedEl.hidden = false;
      addedEl.classList.remove('qlv2-added--fade');
      if (addedTimeout) clearTimeout(addedTimeout);
      addedTimeout = setTimeout(function () {
        addedEl.classList.add('qlv2-added--fade');
        setTimeout(function () { addedEl.hidden = true; }, 300);
      }, 3000);
    }

    if (productFormEl) {
      productFormEl.addEventListener('add-to-cart', function () {
        var addedShade = state.shadeName || 'Item';
        var addedQty = state.qty;

        // Reset qty to 1 for next shade
        state.qty = 1;
        render();

        // T1.1 (2026-05-31): open the branded cart drawer on add. Matches
        // Combine's overlay default + the native main-product section. The
        // shared <product-form> re-renders the drawer contents BEFORE this
        // event fires, so the drawer shows the just-added item. This replaces
        // the old "no drawer interruption" inline toast, which now only fires
        // as a fallback if the drawer can't open.
        var drawerOpened = false;
        if (!document.body.classList.contains('template-cart') &&
            window.KROWN && KROWN.settings && KROWN.settings.cart_action === 'overlay') {
          var cartDrawer = document.getElementById('site-cart-sidebar');
          if (cartDrawer && typeof cartDrawer.show === 'function') {
            cartDrawer.show();
            drawerOpened = true;
          }
          var recDrawer = document.getElementById('cart-recommendations-sidebar');
          if (recDrawer && typeof recDrawer.generateRecommendations === 'function') {
            recDrawer.generateRecommendations();
          }
        }

        // Keep the on-PDP progress bar in sync (seen when the drawer is closed).
        // Show the inline toast only as a fallback when the drawer didn't open.
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var count = 0;
            cart.items.forEach(function (item) {
              if (ELIGIBLE_HANDLES.indexOf(item.handle) !== -1) {
                count += item.quantity;
              }
            });
            updateProgressBar(count, true);
            if (!drawerOpened) showAddedConfirmation(addedShade, addedQty, count);
          })
          .catch(function () {
            if (!drawerOpened) showAddedConfirmation(addedShade, addedQty, 0);
          });
      });
    }

    // ----- Gallery dot pagination + lazy video source swap on active slide
    var gallery = section.querySelector('.ql-gallery');
    var dots = section.querySelectorAll('.ql-gallery__dot');
    if (gallery) {
      var slides = gallery.querySelectorAll('.ql-gallery__slide');
      var hydrateSlide = function (idx) {
        var slide = slides[idx];
        if (!slide) return;
        var lazyVid = slide.querySelector('video[data-ql-lazy-source]');
        if (!lazyVid) return;
        var src = lazyVid.querySelector('source[data-src]');
        if (src) {
          src.setAttribute('src', src.getAttribute('data-src'));
          src.removeAttribute('data-src');
        }
        lazyVid.removeAttribute('data-ql-lazy-source');
        try { lazyVid.load(); lazyVid.play().catch(function () {}); } catch (e) {}
      };
      gallery.addEventListener('scroll', function () {
        var index = Math.round(gallery.scrollLeft / gallery.offsetWidth);
        dots.forEach(function (dot, i) {
          dot.classList.toggle('ql-gallery__dot--active', i === index);
        });
        hydrateSlide(index);
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
